/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const SupplierList = () => {
  document.title = 'Enermerco - Distribuidoras';

  const [isLoading, setIsLoading] = useState(true);

  const [supplierList, setSupplierList] = useState([]);

  const [idDm003, setIdDm003] = useState('');
  const [status, setStatus] = useState('A');
  const [modalStatus, setModalStatus] = useState('');
  const [supplierName, setSupplierName] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalSupplierDesc, setModalSupplierDesc] = useState('');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm003, status, supplierName) => {
    let url = 'supplier?';
    if (status !== 'T' && status !== '') {
      url += `situacao=${status}`;
    }
    if (idDm003 !== '') {
      url += `&id=${idDm003}`;
    }
    if (supplierName !== '') {
      url += `&nome=${supplierName}`;
    }
    api
      .get(url)
      .then((response) => {
        setSupplierList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm003, status, supplierName);
  }, [idDm003, supplierName, status]);

  const cleanFields = useCallback(() => {
    setIdDm003('');
    setStatus('A');
    setSupplierName('');
    applyFilter('', 'A', '');
  }, [idDm003, supplierName, status]);

  const deleteSupplier = useCallback(
    (id) => {
      console.log(id);
      api
        .delete(`supplier?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Distribuidora removida com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addSupplier = useCallback(
    (modalText, _modalNumber1, _modalNumber2, _modalNumber3) => {
      api
        .post(`supplier`, {
          NM_DISTRIBUIDORA: modalText.toUpperCase(),
          IN_SITUACAO: 'A'
        })
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('Distribuidora adicionada com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          toast.success(error);
        });
    },
    [modalAdd]
  );

  const editSupplier = useCallback(
    (modalText, _modalNumber1, _modalNumber2, _modalNumber3, id, modalStatus) => {
      api
        .put(`supplier?id=${id}`, {
          NM_DISTRIBUIDORA: modalText,
          IN_SITUACAO: modalStatus
        })
        .then((response) => {
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('Registro alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalEdit(false);
          toast.success(error);
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(idDm003, status, supplierName);
  }, [status]);

  const statusDescription = (status) => {
    switch (status) {
      case 'A':
        return 'ATIVA';
      case 'I':
        return 'INATIVA';
      default:
        return 'NÃO DEFINIDO';
    }
  };

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Distribuidoras...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de Distribuidoras</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <SelectDefault
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Situação'}
                  value={`${status}`}
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}>
                  <option value="A">ATIVA</option>
                  <option value="I">INATIVA</option>
                  <option value="T">TODOS</option>
                </SelectDefault>
              </Col>
              <Col xs={3}>
                <InputDefault
                  placeholder="Código da Distribuidora"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm003}`}
                  onChange={(e) => setIdDm003(e.target.value)}
                />
              </Col>
              <Col xs={6}>
                <InputDefault
                  placeholder="Nome da Distribuidora"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Nome'}
                  value={`${supplierName}`}
                  onChange={(e) => setSupplierName(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '20%' }}>Nome da Distribuidora</th>
                  <th style={{ width: '10%', textAlign: 'center' }}>Situação</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {supplierList.map((supplier) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{supplier.ID_DM003}</td>
                    <td>{supplier.NM_DISTRIBUIDORA}</td>
                    <td>{statusDescription(supplier.IN_SITUACAO)}</td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setIdDm003(supplier.ID_DM003);
                          setModalSupplierDesc(supplier.NM_DISTRIBUIDORA);
                          setModalStatus(supplier.IN_SITUACAO);
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm003(supplier.ID_DM003);
                          setModalSupplierDesc(supplier.NM_DISTRIBUIDORA);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteSupplier}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir a Distribuidora #${idDm003}?`}
            modalText={modalSupplierDesc}
            id={idDm003}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={addSupplier}
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar nova Distribuidora'}
            modalText={modalSupplierDesc}
            visibleText={true}
            placeHolderText={'Nome'}
            textLabel={'Nome da Distribuidora'}
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={editSupplier}
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar Distribuidora #${idDm003}`}
            visibleText={true}
            textLabel={'Nome da Distribuidora'}
            id={idDm003}
            setModalText={setModalSupplierDesc}
            modalText={modalSupplierDesc}
            modalNumber1={''}
            setModalNumber1={() => {}}
            modalNumber2={''}
            setModalNumber2={() => {}}
            modalNumber3={''}
            setModalNumber3={() => {}}
            visibleStatus={true}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default SupplierList;
